/**
 *
 * @param {HTMLElement} element
 * @param {object} state
 * @param {object} options
 */
export async function createMap(element, state, options) {
	ymaps.ready();

	const map = new ymaps.Map(element, state, options);

	const objectManager = new ymaps.ObjectManager({
		clusterize: true,
		viewportMargin: 0,
	});

	const searchControl = new ymaps.control.SearchControl({
		options: {
			provider: 'yandex#map',
			noPlacemark: true,
		}
	});

	const zoomIn = new ymaps.control.Button({
		options: {
			float: 'none',
			position: {
				top: 24,
				right: 24,
			},
			layout: ymaps.templateLayoutFactory.createClass(`
				<svg class="cursor-pointer" width="48" height="48" viewBox="0 0 48 48" fill="none">
					<circle cx="24" cy="24" r="24" fill="#FDFDFE"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M25 23H30C30.5523 23 31 23.4477 31 24C31 24.5523 30.5523 25 30 25H25V30C25 30.5523 24.5523 31 24 31C23.4477 31 23 30.5523 23 30V25H18C17.4477 25 17 24.5523 17 24C17 23.4477 17.4477 23 18 23H23V18C23 17.4477 23.4477 17 24 17C24.5523 17 25 17.4477 25 18V23Z" fill="#2C353E"/>
				</svg>
			`),
		},
	});

	zoomIn.events.add('click', (event) => {
		const map = event.get('target').getMap();
		const zoom = map.getZoom();

		map.setZoom(zoom + 1, {
			checkZoomRange: true,
			duration: 150,
		});
	});

	const zoomOut = new ymaps.control.Button({
		options: {
			float: 'none',
			position: {
				top: 24 + 48 + 12,
				right: 24,
			},
			layout: ymaps.templateLayoutFactory.createClass(`
				<svg class="cursor-pointer" width="48" height="48" viewBox="0 0 48 48" fill="none">
					<circle cx="24" cy="24" r="24" fill="#FDFDFE"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M24 25H18C17.4477 25 17 24.5523 17 24C17 23.4477 17.4477 23 18 23H30C30.5523 23 31 23.4477 31 24C31 24.5523 30.5523 25 30 25H24Z" fill="#2C353E"/>
				</svg>
			`),
		},
	});

	zoomOut.events.add('click', (event) => {
		const map = event.get('target').getMap();
		const zoom = map.getZoom();

		map.setZoom(zoom - 1, {
			checkZoomRange: true,
			duration: 150,
		});
	});

	const geoLocationButton = new ymaps.control.GeolocationControl({
		options: {
			float: 'none',
			position: {
				top: 24 + 48 * 2 + 12 * 2,
				right: 24,
			},
			layout: ymaps.templateLayoutFactory.createClass(`
				<svg class="cursor-pointer" width="48" height="48" viewBox="0 0 48 48" fill="none">
					<circle cx="24" cy="24" r="24" fill="#FDFDFE"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M24.2298 22.4878L24.2328 22.4868L29.7218 20.0848C29.8181 20.0428 29.9303 20.0655 30.0027 20.1415C30.0752 20.2175 30.0924 20.3307 30.0458 20.4248L27.3688 25.8548L23.8748 32.7078C23.8521 32.7604 23.8108 32.8027 23.7588 32.8268C23.7079 32.8468 23.652 32.8507 23.5988 32.8378C23.545 32.8273 23.4958 32.8004 23.4578 32.7608C23.4207 32.7174 23.4008 32.6619 23.4018 32.6048L23.1978 27.7148C23.171 27.0798 22.6718 26.566 22.0378 26.5208L21.9838 27.2688L22.0368 26.5208L17.0668 26.1668C17.0092 26.1668 16.9536 26.1454 16.9108 26.1068C16.8722 26.0668 16.8471 26.0158 16.8388 25.9608C16.8283 25.9065 16.835 25.8502 16.8578 25.7998C16.8848 25.7488 16.9297 25.7096 16.9838 25.6898L24.2298 22.4868V22.4878Z" stroke="#2C353E" stroke-width="1.5"/>
				</svg>
			`),
		},
	});

	map.geoObjects.add(objectManager);
	map.controls.add(geoLocationButton);
	map.controls.add(zoomIn);
	map.controls.add(zoomOut);
	map.controls.add(searchControl);
	map.panes.get('ground').getElement().style.filter = 'grayscale(100%)';

	return {
		map,
		objectManager,
	}
}
